var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 3.33334H11.3334V2.00001C11.3334 1.26667 10.7334 0.666672 10.0001 0.666672H2.00008C1.26675 0.666672 0.666748 1.26667 0.666748 2.00001V8C0.666748 8.73334 1.26675 9.33334 2.00008 9.33334C2.00008 10.44 2.89341 11.3333 4.00008 11.3333C5.10675 11.3333 6.00008 10.44 6.00008 9.33334H10.0001C10.0001 10.44 10.8934 11.3333 12.0001 11.3333C13.1067 11.3333 14.0001 10.44 14.0001 9.33334H14.6667C15.0334 9.33334 15.3334 9.03334 15.3334 8.66667V6.44667C15.3334 6.16 15.2401 5.88 15.0667 5.64667L13.5334 3.6C13.4067 3.43334 13.2067 3.33334 13.0001 3.33334ZM4.00008 10C3.63341 10 3.33341 9.7 3.33341 9.33334C3.33341 8.96667 3.63341 8.66667 4.00008 8.66667C4.36675 8.66667 4.66675 8.96667 4.66675 9.33334C4.66675 9.7 4.36675 10 4.00008 10ZM13.0001 4.33334L14.3067 6H11.3334V4.33334H13.0001ZM12.0001 10C11.6334 10 11.3334 9.7 11.3334 9.33334C11.3334 8.96667 11.6334 8.66667 12.0001 8.66667C12.3667 8.66667 12.6667 8.96667 12.6667 9.33334C12.6667 9.7 12.3667 10 12.0001 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.201d22304a72af1f6575fa00fbd652c4.svg";
export { ForwardRef as ReactComponent };